import React from 'react';
import { styled } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { Box } from 'shell/components';
import { DrawArc } from 'utils/helper';

const TeamAnalyticsPieChart = ({ role, completed, total, ...rest }) => {
    const theme = useTheme();

    const graphRadius = 12;
    const strokeWidth = role === 'student' ? 0.4 * graphRadius : 0.3 * graphRadius;
    const angles = [0];
    if (total === 0) {
        angles.push(0);
    } else {
        angles.push((completed / total) * 359);
    }

    return (
        <Box {...rest}>
            <CustomSVG viewBox={'-3 -3 30 30'}>
                <DrawArc
                    radius={graphRadius}
                    startAngle={0}
                    endAngle={359}
                    strokeColor={theme.palette.ensightful.primary[100]}
                    strokeWidth={strokeWidth}
                />
                <DrawArc
                    radius={graphRadius}
                    startAngle={angles[0]}
                    endAngle={angles[1]}
                    strokeColor={theme.palette.ensightful.primary[500]}
                    strokeWidth={strokeWidth}
                />
            </CustomSVG>
        </Box>
    );
};

const CustomSVG = styled('svg')(() => {
    return {
        width: 'auto',
        height: 'auto',
    };
});

export default TeamAnalyticsPieChart;
